import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import cx from 'classnames';
import { memo } from 'react';
import { useScreenSize } from '~/context/common/DeviceContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import styles from './OnDemandHero.module.css';
import HeroBadge from '../../HeroBadge';
import HeroVehicleInfo from '../../HeroVehicleInfo';

function useImageUrl(): string {
  const {
    stockImageData: { jellyBeanMobileUrl = '', jellyBeanDesktopUrl = '' } = {}
  } = useGetVehicleDetails();
  const { width } = useScreenSize();

  return width < legacyBreakpoints.m ? jellyBeanMobileUrl : jellyBeanDesktopUrl;
}

const OnDemandHero = () => {
  const imageUrl = useImageUrl();

  return (
    <div className="grid w-full max-w-full border-b border-t border-grey-2 l:grid-cols-[1fr_332px] l:gap-3xl l:p-3xl">
      <div
        className={cx(
          'relative aspect-video w-full overflow-hidden l:flex l:min-h-[375px] l:items-center l:justify-center l:rounded-[6px] l:border l:border-grey-2',
          styles.gradientBackground
        )}
      >
        <div className="pointer-events-none absolute left-0 top-0 z-10 p-8 m:p-16">
          <HeroBadge showTimer />
        </div>
        <img
          src={imageUrl}
          alt="A vehicle"
          className={cx(
            'mt-12 h-full max-h-full w-full translate-y-[-5%] object-cover m:mt-[22px] l:mt-0 l:translate-y-0'
          )}
        />
        <div className="absolute bottom-0 left-[50%] right-[50%] w-full translate-x-[-50%] translate-y-[-50%] text-center m:bottom-[10px] l:bottom-[20px]">
          <p className="tl-body-s">© Carvana, LLC Stock Image</p>
        </div>
      </div>
      <HeroVehicleInfo />
    </div>
  );
};

export default memo(OnDemandHero);
